import { createBrowserRouter } from "react-router-dom";
import { routes } from "./routes/routes";

export const router = createBrowserRouter(routes);
